import { BillingListComponent } from './list/list.component';
import { BillingService } from './billing.service';
import { CellItemType } from './billing-page.types';
import { Component, Inject, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { WINDOW } from '@benefitsui/app/lib/tokens/window';

@Component({
  selector: 'app-billing-page',
  templateUrl: './billing-page.component.html',
  styleUrls: ['./billing-page.component.scss']
})
export class BillingPageComponent {
  constructor(
    @Inject(WINDOW) private window: Window,
    private billingService: BillingService
  ) {
    this.componentName$ = this.billingService.screenName$;
    this.cardHeader$ = this.componentName$.pipe(
      map((s) => {
        switch (s) {
          case 'list':
            return 'Billing';
          case 'payment':
            return 'Pay invoice(s)';
          case 'premium':
            return 'Premium calculation';
          default:
            return 'Billing';
        }
      })
    );
  }

  // :  Data members
  cardHeader$: Observable<string>;
  componentName$: Observable<string>;

  @ViewChild('listForm')
  private listForm!: BillingListComponent;

  // ngOnInit(): void {
  // }

  // ngOnDestroy(): void {
  // }

  goPayment(selectedTable: CellItemType[]) {
    this.billingService.setPayment(selectedTable);
    if (selectedTable.length > 0) {
      this.billingService.setComponent('payment');
      this.billingService.setTotalAmount(this.totalAmount());
      this.scrollToTop();
    }
  }

  goBillingList() {
    this.billingService.setComponent('list');
    this.scrollToTop();
  }

  goPremium() {
    this.billingService.setComponent('premium');
    this.scrollToTop();
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }

  payNow() {
    this.scrollToTop();
  }

  totalAmount() {
    return this.listForm.selectedItems.reduce((sum, current) => sum + current.amount, 0);
  }
}
